// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { prepareAdminAuthStorage } from './auth-storage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Keep admin sessions only for the lifetime of the current browser tab.
    // This still supports reloads while avoiding durable refresh tokens in localStorage.
    storage: prepareAdminAuthStorage(SUPABASE_URL, window.localStorage, window.sessionStorage),
    persistSession: true,
    autoRefreshToken: true,
  }
});
